import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinjalndhar() {



  const cardData =
  {
    keyword: 'Corporate Cab Services in Jalandhar',
    heading: 'Aaryan Travels: Corporate Cab Services in Jalandhar',
    headingDescription: ' Aaryan Travels offers professional Corporate Cab Services in Jalandhar, catering to businesses, manufacturing units, and corporate executives who require reliable and punctual transportation. Whether you need daily staff commuting, client pickups, airport transfers from Amritsar or Chandigarh, or intercity travel for meetings and factory visits, our fleet of sedans, SUVs, and luxury vehicles ensures a smooth and comfortable journey. With trained chauffeurs, GPS-enabled cars, monthly rental options, and 24/7 availability, we provide fully managed corporate mobility across Jalandhar. From industrial areas like Focal Point and Leather Complex to IT and commercial zones, Aaryan Travels is the trusted partner for dependable corporate cab services in Jalandhar.',

    top: 'Top Places to Visit in Jalandhar with Aaryan Travels',

"topPlaces": [
  {
    "title": "Devi Talab Mandir",
    "description": "Devi Talab Mandir is one of the oldest temples in Jalandhar dedicated to Goddess Durga. The temple complex includes a sacred pond believed to be over 200 years old. A replica of the Amarnath Cave and a Maa Kali temple enhance the divine ambiance. Devotees visit throughout the year, especially during Navratri celebrations. Devi Talab Mandir is Jalandhar’s spiritual crown of faith."
  },
  {
    "title": "Wonderland Theme Park",
    "description": "Wonderland is Jalandhar’s most popular amusement and water park, offering thrilling rides, wave pools, and fun activities for all age groups. Attractions like roller coasters, boat rides, and aqua dance floors make it a perfect weekend getaway. Kids enjoy the toy train and water slides with great excitement. Wonderland is Jalandhar’s ultimate hub of fun and adventure."
  },
  {
    "title": "Pushpa Gujral Science City",
    "description": "Pushpa Gujral Science City is a futuristic learning destination that blends science with entertainment. It features 3D theaters, space galleries, dinosaur parks, and interactive exhibits. Laser shows and simulation rides attract both students and families. The vast campus encourages curiosity and exploration. Science City is Jalandhar’s innovative world of knowledge and discovery."
  },
  {
    "title": "Rangla Punjab Haveli",
    "description": "Rangla Punjab Haveli is a cultural resort that recreates traditional Punjabi village life with live folk performances, bhangra shows, and puppet dances. Guests enjoy an unlimited Punjabi buffet served in authentic style. Mud houses, bullock carts, and artisans add to the rural experience. Rangla Punjab is Jalandhar’s vibrant celebration of Punjabi culture and hospitality."
  },
  {
    "title": "Nikku Park",
    "description": "Nikku Park is a well-maintained children’s amusement park featuring paddle boats, swings, and lush gardens. Families enjoy evening strolls and snacks from local vendors. The peaceful surroundings make it ideal for picnics and relaxation. It is especially loved by kids for its playful atmosphere. Nikku Park is Jalandhar’s refreshing family escape."
  },
  {
    "title": "Tulsi Mandir",
    "description": "Tulsi Mandir is a revered ancient temple dedicated to Vrinda Devi, located near the Devi Talab. It also houses shrines of Lord Krishna and Goddess Durga. The peaceful setting and traditional rituals attract devotees seeking spiritual solace. The temple complex holds mythological significance. Tulsi Mandir is Jalandhar’s calm abode of devotion."
  },
  {
    "title": "Imam Nasir Mausoleum and Jama Masjid",
    "description": "This historic complex includes a 800-year-old mausoleum of Imam Nasir and an adjoining 400-year-old mosque. The Mughal-style architecture with domes and arches reflects the city’s diverse spiritual heritage. Devotees from different faiths visit for blessings and peace. Festivals and gatherings add liveliness to the premises. Imam Nasir Mausoleum is Jalandhar’s symbol of unity and tradition."
  },
  {
    "title": "Gurdwara Chhevin Patshahi",
    "description": "Gurdwara Chhevin Patshahi is a prominent Sikh shrine associated with Guru Hargobind Sahib, the sixth Sikh Guru. The serene white structure and langar services welcome devotees with warmth and equality. Daily prayers and community gatherings make it spiritually vibrant. Gurdwara Chhevin Patshahi is Jalandhar’s sacred haven of Sikh devotion."
  },
  {
    "title": "Sodal Mandir",
    "description": "Sodal Mandir is dedicated to Baba Sodal, a revered child deity of Jalandhar. The annual fair held here in September attracts thousands of devotees. The temple’s colorful decorations and rituals create a festive atmosphere. People visit to seek blessings for children and family harmony. Sodal Mandir is Jalandhar’s symbol of local faith and tradition."
  },
  {
    "title": "BMC Chowk & Shopping Markets",
    "description": "BMC Chowk is one of Jalandhar’s busiest intersections, surrounded by vibrant markets selling fashion, footwear, and electronics. Nearby Model Town Market and Rainak Bazaar are famous for bridal wear and accessories. Street food stalls offer chaats, parathas, and Punjabi sweets. The lively atmosphere makes evening strolls delightful. BMC Chowk is Jalandhar’s commercial heartbeat."
  }
],


"services": [
  {
    "name": "Corporate Cab Services in Jalandhar",
    "description": "Our Corporate Cab Services in Jalandhar are tailored to meet the daily commuting needs of companies, employees, and executives. We provide professional and punctual transportation solutions that enhance corporate mobility. With a well-maintained fleet of sedans, SUVs, and premium cars driven by trained chauffeurs, we ensure seamless travel across Jalandhar. Whether it’s regular office pickups, business meetings, or airport transfers, our services are reliable, efficient, and cost-effective. We also offer monthly billing, priority bookings, and dedicated account managers for enterprise clients."
  },
  {
    "name": "Jalandhar Business Taxi",
    "description": "Jalandhar Business Taxi service is designed for working professionals and business travelers who need timely, comfortable, and safe travel within the city. Our taxis are equipped with air-conditioning, clean interiors, and professional chauffeurs who understand the value of your time. Book for single trips, hourly usage, or full-day rentals at competitive business rates."
  },
  {
    "name": "Employee Cab Jalandhar",
    "description": "Our Employee Cab services in Jalandhar provide safe and reliable daily transportation for your workforce. Whether you run a factory, BPO, or corporate office, we handle employee shift transportation with precision. From GPS-enabled vehicles to trained drivers and real-time tracking, we ensure punctuality and safety for all staff members across locations."
  },
  {
    "name": "Chauffeur Driven Corporate Cab Jalandhar",
    "description": "Get a premium travel experience with our Chauffeur Driven Corporate Cab service in Jalandhar. Ideal for executives and business clients, our chauffeur-driven cars are maintained to the highest standards and offer comfort, privacy, and convenience. Our drivers are professionally trained, uniformed, and adhere to corporate etiquette at all times."
  },
  {
    "name": "Office Transport Jalandhar",
    "description": "Our Office Transport service in Jalandhar offers end-to-end mobility solutions for daily office commutes, client visits, and team outings. We provide multi-route planning, route optimization, and centralized coordination to ensure timely pickups and drops, improving employee satisfaction and productivity while reducing administrative overhead for your company."
  },
  {
    "name": "Staff Cab Jalandhar",
    "description": "Staff Cab services in Jalandhar are perfect for businesses looking to provide secure and scheduled transportation to their employees. Our fleet includes compact cars, sedans, and SUVs, all managed by experienced drivers. We offer shift-based transport planning, flexible billing, and route customization for maximum efficiency."
  },
  {
    "name": "Monthly Corporate Cab Jalandhar",
    "description": "Subscribe to our Monthly Corporate Cab plans in Jalandhar and enjoy consistent, worry-free transportation for your team. Perfect for businesses with regular cab needs, this plan includes fixed monthly rates, priority dispatch, assigned vehicles, and dedicated support. Whether for executives or operational staff, we provide flexible options to suit every organization."
  },
  {
    "name": "Affordable Business Cab Jalandhar",
    "description": "Our Affordable Business Cab service in Jalandhar combines cost-efficiency with corporate-class service. Get high-quality rides at competitive rates without compromising on vehicle quality, driver professionalism, or punctuality. Designed for startups, SMEs, and enterprises looking for value-based travel solutions."
  },
  {
    "name": "Company Cab Services Jalandhar",
    "description": "Company Cab Services in Jalandhar are ideal for organizations that need daily cab support for staff movement, official duties, or guest transportation. We offer easy fleet management, digital invoicing, usage reporting, and centralized support to help businesses streamline their employee travel without operational headaches."
  },
  {
    "name": "Premium Corporate Taxi Jalandhar",
    "description": "Travel in luxury and style with our Premium Corporate Taxi services in Jalandhar. Featuring top-tier vehicles like executive sedans and SUVs, this service is ideal for CXOs, VIP clients, or high-value meetings. Onboard amenities, courteous chauffeurs, and flexible booking make this a perfect choice for elite business travel."
  },
  {
    "name": "Jalandhar Sedan Corporate Rental",
    "description": "Jalandhar Sedan Corporate Rental offers comfortable, air-conditioned sedans for executives and office staff. These cars are well-suited for city travel, official client visits, and airport transfers. Enjoy features like onboard Wi-Fi, phone charging, and complimentary water bottles for a refined business-class experience."
  },
  {
    "name": "SUV Hire Corporate Jalandhar",
    "description": "Need extra space or a premium look for your business travel? Our SUV Hire for Corporate needs in Jalandhar is the ideal choice. Perfect for group travel, long-distance meetings, or executive delegations, our SUVs combine comfort, style, and functionality with the backing of professional drivers and flexible rental plans."
  },
  {
    "name": "Reliable Business Cab Jalandhar",
    "description": "For dependable and punctual transportation, choose our Reliable Business Cab service in Jalandhar. We maintain high operational standards with fleet availability, route accuracy, and vehicle safety checks. Perfect for regular and urgent business travel needs within and around the city."
  },
  {
    "name": "Online Corporate Cab Jalandhar",
    "description": "Book corporate cabs in Jalandhar online with our intuitive, secure booking platform. Manage all your travel needs in one place, from scheduling pickups to reviewing invoices. Features like real-time tracking, digital payment, and SMS/email confirmations make travel management effortless for businesses of all sizes."
  },
  {
    "name": "Executive Car Rental Jalandhar",
    "description": "Our Executive Car Rental service in Jalandhar offers high-end vehicles with professional chauffeurs for executives, consultants, and VIP guests. Choose from a fleet of luxury sedans and SUVs for meetings, client visits, or airport transfers. Custom packages available for daily, weekly, or monthly use."
  }
],
"tableData": [
  ["Corporate Cab Services in Jalandhar", "Jalandhar Business Taxi"],
  ["Employee Cab Jalandhar", "Chauffeur Driven Corporate Cab Jalandhar"],
  ["Office Transport Jalandhar", "Staff Cab Jalandhar"],
  ["Monthly Corporate Cab Jalandhar", "Affordable Business Cab Jalandhar"],
  ["Company Cab Services Jalandhar", "Premium Corporate Taxi Jalandhar"],
  ["Jalandhar Sedan Corporate Rental", "SUV Hire Corporate Jalandhar"],
  ["Reliable Business Cab Jalandhar", "Online Corporate Cab Jalandhar"],
  ["Executive Car Rental Jalandhar", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Corporate Cab Services in Jalandhar",
    "WhyChoosedescription": "Aaryan Travels offers dependable and professional corporate cab services tailored for businesses in Jalandhar."
  },
  {
    "WhyChooseheading": "Punctual Pickup and Drop for Office Commutes",
    "WhyChoosedescription": "Ensure timely transportation for your employees with our well-managed and on-time cab services."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles for Business Travel",
    "WhyChoosedescription": "All our cabs are sanitized, air-conditioned, and maintained to provide a comfortable and safe ride."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Knowledge of Local Routes",
    "WhyChoosedescription": "Our trained drivers are familiar with Jalandhar’s business hubs and traffic patterns for efficient navigation."
  },
  {
    "WhyChooseheading": "Transparent Corporate Billing with No Hidden Costs",
    "WhyChoosedescription": "Enjoy GST-compliant invoices and all-inclusive pricing for smooth corporate accounting."
  },
  {
    "WhyChooseheading": "24/7 Dedicated Support for Corporate Clients",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, modifications, and queries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans: Daily, Weekly, or Monthly",
    "WhyChoosedescription": "Choose from various rental options that suit your organization’s travel policies and needs."
  },
  {
    "WhyChooseheading": "Wide Fleet for Every Corporate Requirement",
    "WhyChoosedescription": "Select from sedans, SUVs, and tempo travellers based on executive, staff, or client transportation needs."
  }
]






























  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer corporate cab services in Jalandhar?',
    answer: 'Yes, Aaryan Travels provides reliable and professional corporate cab services across Jalandhar, tailored to business travel requirements.',
  },
  {
    question: 'How can I book corporate cab services in Jalandhar with Aaryan Travels?',
    answer: 'Corporate clients can book cabs through our website, mobile app, or by contacting our dedicated corporate service team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services in Jalandhar?',
    answer: 'We offer a wide range of vehicles including sedans, SUVs, and premium cars suitable for executive and employee transportation.',
  },
  {
    question: 'Are Aaryan Travels’ corporate cabs suitable for employee commute in Jalandhar?',
    answer: 'Yes, we provide daily employee pickup and drop-off services for companies in and around Jalandhar.',
  },
  {
    question: 'Are your drivers trained for corporate cab services in Jalandhar?',
    answer: 'Absolutely. Our drivers are professional, courteous, and well-trained to meet corporate travel standards.',
  },
  {
    question: 'Can Aaryan Travels handle group cab bookings for corporate events in Jalandhar?',
    answer: 'Yes, we specialize in managing bulk cab bookings and group transportation for conferences, meetings, and corporate events.',
  },
  {
    question: 'Do you offer monthly billing options for corporate clients in Jalandhar?',
    answer: 'Yes, we provide flexible billing solutions including monthly invoicing for corporate cab services in Jalandhar.',
  },
  {
    question: 'Is your corporate cab service available 24x7 in Jalandhar?',
    answer: 'Yes, Aaryan Travels offers round-the-clock corporate cab services to support all business travel needs.',
  },
  {
    question: 'What safety protocols are followed in corporate cab services in Jalandhar?',
    answer: 'All our cabs are sanitized regularly and our drivers follow strict hygiene and safety measures.',
  },
  {
    question: 'Can pickup and drop-off locations be customized for corporate bookings in Jalandhar?',
    answer: 'Yes, we offer full flexibility for custom pickup and drop-off points based on your corporate schedule.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Mehra',
    feedback: 'Aaryan Travels has been our trusted partner for corporate cabs in Jalandhar. Always on time and very professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sonal Arora',
    feedback: 'Excellent service, clean vehicles, and courteous drivers. Our team relies on Aaryan Travels for all our corporate travel in Jalandhar.',
    rating: 5,
  },
];




























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Jalandhar",
  "image": "https://aaryantravels.com/assets/images/corporate-cab-jalandhar.jpg", // replace with actual image URL
  "description": "Professional and affordable corporate cab services in Jalandhar by Aaryan Travels. Perfect for employee transport, business travel, and office commutes with premium sedans and SUVs.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",  // example rating, update if needed
    "ratingCount": "1300", // example rating count, update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1200",  // example price, adjust as needed
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/corporate-cab-services-jalandhar"
  }
};





  return (
    <div>
<Helmet>
  <title>Corporate Cab Services in Jalandhar | Business Taxi | Aaryan Travels</title>
  <meta
    name="description"
    content="Professional and affordable corporate cab services in Jalandhar by Aaryan Travels. Perfect for employee transport, business travel, and office commutes with premium sedans and SUVs."
  />
  <meta
    name="keywords"
    content="Corporate Cab Services in Jalandhar, Jalandhar Business Taxi, Employee Cab Jalandhar, Chauffeur Driven Corporate Cab Jalandhar, Office Transport Jalandhar, Staff Cab Jalandhar, Monthly Corporate Cab Jalandhar, Affordable Business Cab Jalandhar, Company Cab Services Jalandhar, Premium Corporate Taxi Jalandhar, Jalandhar Sedan Corporate Rental, SUV Hire Corporate Jalandhar, Reliable Business Cab Jalandhar, Online Corporate Cab Jalandhar, Executive Car Rental Jalandhar"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/30.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinjalndhar;